import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import LandingScreen from './screens/LandingScreen';
import DebtDetailsScreen from './screens/DebtDetailsScreen';
import Screen3 from './screens/Screen3';
import Screen4 from './screens/Screen4';
import Screen5 from './screens/Screen5';
import Screen6 from './screens/Screen6';

const AutoNavigateWrapper: React.FC<{ children: React.ReactNode; nextPath: string; delay?: number }> = ({ children, nextPath, delay = 1000 }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      navigate(nextPath);
    }, delay);

    return () => clearTimeout(timer);
  }, [navigate, nextPath, delay]);

  return (
    <div className="h-screen w-full">
      {children}
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="App h-screen w-full max-w-[390px] mx-auto relative overflow-hidden shadow-2xl">
        <Routes>
          <Route path="/" element={
            <AutoNavigateWrapper nextPath="/screen2" delay={2000}>
              <LandingScreen />
            </AutoNavigateWrapper>
          } />
          <Route path="/screen2" element={<DebtDetailsScreen />} />
          <Route path="/screen3" element={<Screen3 />} />
          <Route path="/screen4" element={<Screen4 />} />
          <Route path="/screen5" element={<Screen5 />} />
          <Route path="/screen6" element={<Screen6 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;